import {
    AdminDashboardPage,
      DAllBlogsPage,
      CreateBlogPage,
      EditBlogPage,
      EditVideoCategoryPage,
      EditVideoPage,
      EditReviewPage,
      EditServicePage,
      EditCategoryPage,
      EditBookPage,
      EditUserRolePage,
      EditPleadingPage,
      EditCasePage,
      DallCasePage,
      DallPleadingPage,
      DAllVideosPage,
      DAllVideoCategoryPage,
      DAllServicesPage,
      DAllReviewsPage,
      DAllCategoryPge,
      DAllBooksPage,
      CreateVideoPage,
      CreateVideoCategoryPage,
      CreateServicePage,
      CreateReviewPage,
      CreateBookPage,
      CreateCategoryPage,
      CreatePleadingPage,
      CreateCasePage,
      ViewCasePage,
      ViewPleadingPage


  } from "../pages/admindashboard";

export const AdminRouters = [
    { path: "/admin", element: <AdminDashboardPage /> },
    { path: "/EditBlogPage/:id", element: <EditBlogPage /> },
    { path: "/EditVideoCategoryPage/:id", element: <EditVideoCategoryPage /> },
    { path: "/EditVideoPage/:id", element: <EditVideoPage /> },
    { path: "/EditReviewPage/:id", element: <EditReviewPage /> },
    { path: "/EditServicePage/:id", element: <EditServicePage /> },
    { path: "/EditCategoryPage/:id", element: <EditCategoryPage /> },
    { path: "/EditBookPage/:id", element: <EditBookPage /> },
    { path: "/EditUserRolePage/:id", element: <EditUserRolePage /> },
    { path: "/EditPleading/:id", element: <EditPleadingPage /> },
    { path: "/EditCase/:id", element: <EditCasePage /> },


    { path: "/DAllBlogsPage", element: <DAllBlogsPage /> },
    { path: "/DAllVideosPage", element: <DAllVideosPage /> },
    { path: "/DAllVideoCategoryPage", element: <DAllVideoCategoryPage /> },
    { path: "/DAllServicesPage", element: <DAllServicesPage /> },
    { path: "/DAllReviewsPage", element: <DAllReviewsPage /> },
    { path: "/DAllCategoryPge", element: <DAllCategoryPge /> },
    { path: "/DAllBooksPage", element: <DAllBooksPage /> },
    { path: "/DallPleading", element: <DallPleadingPage /> },
    { path: "/DallCase", element: <DallCasePage /> },


    { path: "/CreateBlogPage", element: <CreateBlogPage /> },
    { path: "/CreateVideoPage", element: <CreateVideoPage /> },
    { path: "/CreateVideoCategoryPage", element: <CreateVideoCategoryPage /> },
    { path: "/CreateServicePage", element: <CreateServicePage /> },
    { path: "/CreateReviewPage", element: <CreateReviewPage /> },
    { path: "/CreateBookPage", element: <CreateBookPage /> },
    { path: "/CreateCategoryPage", element: <CreateCategoryPage /> },
    { path: "/CreatePleading", element: <CreatePleadingPage /> },
    { path: "/CreateCase", element: <CreateCasePage /> },

    { path: "/ViewCasePage/:id", element: <ViewCasePage /> },
    { path: "/ViewPleadingPage/:id", element: <ViewPleadingPage /> },
   
  ];